import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Field, reduxForm } from "redux-form";
import {
  Card,
  CardHeader,
  CardBody,
  Row,
  Col,
  Button,
  Input,
  Label,
  Form,
  FormGroup,
  Alert,
  FormFeedback,
} from "reactstrap";
import { validationHelper, normalizeHelper } from "../../../../common/helpers";
import { messages } from "../../../../common/constants";
import { toast } from "react-toastify";
import { MainLoader } from "../../../../components";
import {
  getStore,
  updateStore,
  resetUpdateStore,
  resetStore,
} from "../../../../store/store/actions";

class StoreEdit extends Component {
  constructor(props) {
    super(props);

    this.onSubmit = this.onSubmit.bind(this);
  }

  componentDidMount() {
    this.props.getStore(this.props.match.params.id);
  }

  componentDidUpdate(prevProps) {
    this.checkStoreUpdateSuccess(prevProps);
  }
  componentWillUnmount() {
    this.props.resetStore();
    this.props.resetUpdateStore();
  }
  checkStoreUpdateSuccess(prevProps) {
    if (prevProps.updatedStore == null && this.props.updatedStore != null) {
      toast.success("Tienda actualizada satisfactoriamente");
      this.props.history.push("/administration/stores");
    }
  }

  onSubmit(values) {
    this.props.updateStore(this.props.match.params.id, values);
  }

  renderInputField(field) {
    const {
      meta: { touched, error },
    } = field;
    const hasError = touched && error ? true : false;
    const labelClass = field.labelClass ? field.labelClass : "mt-1";

    return (
      <FormGroup row>
        <Col md="2" lg="1">
          <Label className={labelClass}>{field.label}</Label>
        </Col>
        <Col xs="12" md="5">
          <Input {...field.input} invalid={hasError} type={field.type} />
          {hasError == true ? <FormFeedback>{error}</FormFeedback> : null}
        </Col>
      </FormGroup>
    );
  }

  render() {
    const {
      handleSubmit,
      error,
      loading,
      updatedLoading,
      updatedError,
      initialValues,
    } = this.props;
    const isLoadingFetch = loading;
    const isLoadingSubmit = updatedLoading;

    if (error) {
      return <Alert color="danger">{error}</Alert>;
    }
    if (isLoadingFetch) {
      return <MainLoader />;
    }
    return (
      <div className="animated">
        {isLoadingFetch ? (
          <MainLoader />
        ) : (
          <Card>
            <CardHeader>Editar Tienda</CardHeader>
            <CardBody>
              {updatedError && <Alert color="danger">{updatedError}</Alert>}
              <Form onSubmit={handleSubmit(handleSubmit(this.onSubmit))}>
                <Field
                  name="name"
                  label="Nombre:"
                  type="text"
                  component={this.renderInputField}
                />
                <Field
                  name="ruc"
                  label="RUC:"
                  type="text"
                  component={this.renderInputField}
                  normalize={normalizeHelper.numberOnlyField(11)}
                />
                <Field
                  name="businessName"
                  label="Razón Social:"
                  type="text"
                  component={this.renderInputField}
                />
                <Field
                  name="address"
                  label="Dirección:"
                  type="text"
                  component={this.renderInputField}
                />
                <Field
                  name="longitude"
                  label="Longitud:"
                  type="text"
                  component={this.renderInputField}
                />
                <Field
                  name="latitude"
                  label="Latitud:"
                  type="text"
                  component={this.renderInputField}
                />
                <Field
                  name="phone"
                  label="Teléfono:"
                  type="text"
                  component={this.renderInputField}
                  normalize={normalizeHelper.numberOnlyField(9)}
                />
                <Field
                  name="openingHours"
                  label="Horario de Atención:"
                  placeholder="08:00 - 20:00"
                  type="text"
                  component={this.renderInputField}
                />
                <FormGroup row>
                  <Col md="2" lg="1">
                    <Label color="red">Usuario *:</Label>
                  </Col>
                  <Col xs="12" md="5">
                    <p className="form-control-static">
                      {initialValues && initialValues.User
                        ? initialValues.User.name
                        : ""}
                    </p>
                  </Col>
                </FormGroup>
                <Field
                  name="username"
                  label="Usuario Tienda Escontech (Facturación Electrónica): "
                  component={this.renderInputField}
                />
                <Field
                  name="password"
                  label="Contraseña Tienda Escontech (Facturación Electrónica): "
                  type="password"
                  component={this.renderInputField}
                />
                <Field
                  name="url"
                  label="URL Ticket Impreso (Facturación Electrónica):"
                  type="text"
                  component={this.renderInputField}
                />
                <Row>
                  <Col className="mt-3">
                    <Button
                      type="submit"
                      disabled={isLoadingSubmit}
                      color="primary"
                      className="mr-2"
                    >
                      <i className="fa fa-save mr-1" /> Guardar
                    </Button>
                    <Button
                      color="secondary"
                      onClick={() =>
                        this.props.history.push("/administration/stores")
                      }
                    >
                      <i className="fa fa-chevron-left mr-1" /> Cancelar
                    </Button>
                  </Col>
                </Row>
              </Form>
            </CardBody>
          </Card>
        )}
      </div>
    );
  }
}

function validate(values) {
  const errors = {};

  if (validationHelper.stringIsNullOrEmpty(values.name)) {
    errors.name = messages.MANDATORY_FIELD;
  }

  if (validationHelper.stringIsNullOrEmpty(values.ruc)) {
    errors.ruc = messages.MANDATORY_FIELD;
  } else if (!validationHelper.isNumber(values.ruc, 11)) {
    errors.ruc = messages.RUC_FORMAT_FIELD;
  }

  if (validationHelper.stringIsNullOrEmpty(values.businessName)) {
    errors.businessName = messages.MANDATORY_FIELD;
  }

  if (validationHelper.stringIsNullOrEmpty(values.address)) {
    errors.address = messages.MANDATORY_FIELD;
  }

  if (!values.longitude) errors.longitude = messages.MANDATORY_FIELD;
  if (!values.latitude) errors.latitude = messages.MANDATORY_FIELD;

  if (validationHelper.stringIsNullOrEmpty(values.phone)) {
    errors.phone = messages.MANDATORY_FIELD;
  } else if (!validationHelper.isPhone(values.phone)) {
    errors.phone = messages.PHONE_FORMAT_FIELD;
  }

  if (
    validationHelper.stringIsNullOrEmpty(values.user_id) ||
    values.user_id == "0"
  ) {
    errors.user_id = messages.MANDATORY_FIELD;
  }

  if (validationHelper.stringIsNullOrEmpty(values.username)) {
    errors.username = messages.MANDATORY_FIELD;
  }
  return errors;
}

function mapStateToProps(state) {
  const { store, error, loading } = state.store.activeStore;
  if (store) store.password = "";
  return {
    initialValues: store
      ? { ...store, openingHours: store.openingHoursService }
      : null,
    loading,
    error,
    updatedStore: state.store.updateStore.store,
    updatedError: state.store.updateStore.error,
    updatedLoading: state.store.updateStore.loading,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getStore,
      updateStore,
      resetUpdateStore,
      resetStore,
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  reduxForm({
    form: "StoreEditForm",
    touchOnBlur: false,
    keepDirtyOnReinitialize: true,
    enableReinitialize: true,
    validate,
  })(StoreEdit)
);



// WEBPACK FOOTER //
// ./src/scenes/Administration/Store/StoreEdit/StoreEdit.js